// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/low-level-speed.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/low-level-speed/low-level-speed.js';

mount([g0]);
